import React from 'react';
import PropTypes from 'prop-types';
import SelectInputWrapper from '../SelectInputWrapper';

const SelectRecordsPerPage = ({
	pageSize,
	onPageSizeChange,
	totalElements,
	label
}) => {
	const pageSizeOption = [
		{ key: '10', value: 10, text: '10' },
		{ key: '20', value: 20, text: '20' },
		{ key: '100', value: 100, text: '100' }
	];

	return (
		<div>
			<div
				className="displayInlineBlock"
				style={{ width: '60px' }}
			>
				<SelectInputWrapper
					name="pageSize"
					value={pageSize}
					options={pageSizeOption}
                    onChange={onPageSizeChange}
                    className="filteringDropdown"
				/>
			</div>

			<div className="displayInlineBlock">
                {label}
				{totalElements}
			</div>
		</div>
	);
};

SelectRecordsPerPage.propTypes = {
	pageSize: PropTypes.number.isRequired,
	onPageSizeChange: PropTypes.func.isRequired,
	totalElements: PropTypes.number,
	label: PropTypes.string
};

SelectRecordsPerPage.defaultProps = {
	totalElements: 0,
	label: 'Total Records: '
};

export default SelectRecordsPerPage;
